import React, {Component} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {FormattedMessage} from 'react-intl';
import messages from '../../res/translations/messages';
import PagerItem from './PagerItem';
import Icon from './Icon';

class Pager extends Component {
    goTo(number) {
        return () => this.props.onClick(number);
    }

    render() {
        const {className, current, pages} = this.props;
        if (pages < 2) {
            return null;
        }

        const numbers = [];

        const start = Math.max(1, current - 2);
        const end = Math.min(pages, current + 2);
        if (start > 1) {
            numbers.push(<PagerItem key={1} onClick={this.goTo(1)} active={current === 1}>1</PagerItem>);
            if (start > 2) {
                numbers.push(<PagerItem key="ellipsis-lo">…</PagerItem>);
            }
        }
        for (let n = start; n <= end; n++) {
            numbers.push(<PagerItem key={n} onClick={this.goTo(n)} active={current === n}>{n}</PagerItem>);
        }
        if (end < pages) {
            if (end < pages - 1) {
                numbers.push(<PagerItem key="ellipsis-hi">…</PagerItem>);
            }
            numbers.push(<PagerItem key={pages} onClick={this.goTo(pages)} active={current === pages}>{pages}</PagerItem>);
        }

        return (
            <ul className={classNames(className, 'pagination pagination-sm')}>
                <li className="page-item">
                    <a className="page-link" onClick={this.goTo(current - 1 < 1 ? 1 : current - 1)}>
                        <span aria-hidden="true"><Icon icon="double_arrow_left" /></span>
                        <span className="sr-only"><FormattedMessage {...messages.pager.prev} /></span>
                    </a>
                </li>
                {numbers}
                <li className="page-item">
                    <a className="page-link" onClick={this.goTo(current + 1 > pages ? pages : current + 1)}>
                        <span aria-hidden="true"><Icon icon="double_arrow_right" /></span>
                        <span className="sr-only"><FormattedMessage {...messages.pager.next} /></span>
                    </a>
                </li>
            </ul>
        );
    }
}

Pager.propTypes = {
    className: PropTypes.string,
    current: PropTypes.number.isRequired,
    onClick: PropTypes.func.isRequired,
    pages: PropTypes.number.isRequired,
};

export default Pager;
